<template>
  <div
    ref="container"
    :style="{
      transition: 'height 300ms ease-in-out, opacity 300ms ease-in-out',
      overflow: open ? 'visible' : 'hidden',
      opacity: open ? '1' : '0'
    }"
  >
    <div ref="innerContainer" v-bind="innerContainerProps">
      <slot name="items" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      default: true
    },

    itemsToWatch: {
      type: Object,
      default() {
        return {}
      }
    },

    innerContainerProps: {
      type: Object,
      defualt() {
        return {}
      }
    }
  },

  created() {
    this.resizeObserver = new ResizeObserver((entries) => {
      const container = this.$refs.container
      if (container && this.open === true && this.$breakpoints.smAndDown) {
        for (const entry of entries) {
          this.$nextTick(() => {
            container.style.height = `${entry.target.scrollHeight}px`
          })
        }
      }
    })
  },

  beforeDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect
    }
  },

  mounted() {
    const item = this.$slots.items
    const container = this.$refs.container
    const innerContainer = this.$refs.innerContainer
    if (item && container) {
      this.transitionContainer()
    }

    if (this.resizeObserver) {
      this.resizeObserver.observe(innerContainer)
    }
  },

  watch: {
    open() {
      this.transitionContainer()
    },

    itemsToWatch: {
      deep: true,
      handler() {
        this.transitionContainer()
      }
    }
  },

  methods: {
    transitionContainer() {
      this.$nextTick(() => {
        const container = this.$refs.container
        const innerContainer = this.$refs.innerContainer
        if (container) {
          if (this.$breakpoints.smAndDown) {
            if (this.open) {
              container.style.height = `${innerContainer.scrollHeight}px`
            } else {
              container.style.height = 0
            }
          } else {
            container.style.height = 'auto'
          }
        }
      })
    }
  }
}
</script>
